import { forwardRef, Ref } from 'react';
import {
  Box,
  BoxProps as MUIBoxProps,
  PopperProps as MUIPopperProps,
  Tooltip as MUITooltip,
  TooltipProps as MUITooltipProps,
} from '@mui/material';
import { boxShadow2, S2, S5 } from '../../theme';
import { TYPOGRAPHY_CAPTION } from '../Typography';
import { mergeSX } from '../../services/helpers';

interface IBuildBoxStylesProps {
  cursorPointer?: boolean;
}

export interface ITooltipProps extends IBuildBoxStylesProps, MUITooltipProps {
  PopperProps?: Partial<MUIPopperProps>;
  boxSX?: MUIBoxProps['sx'];
}

const buildTooltipSX = () => ({
  '& .MuiTooltip-tooltip': {
    ...TYPOGRAPHY_CAPTION,
    color: S5,
    backgroundColor: S2,
    border: `1px solid ${S2}`,
    borderRadius: '8px',
    boxShadow: boxShadow2,
    padding: '8px 16px',
  },
});

const buildBoxSX = ({ cursorPointer }: IBuildBoxStylesProps) => ({
  display: 'inline-grid',
  cursor: cursorPointer ? 'pointer' : 'auto',
});

const Tooltip = forwardRef((props: ITooltipProps, ref) => {
  const {
    children,
    cursorPointer = false,
    boxSX,
    PopperProps = {},
    ...restProps
  } = props;

  return (
    <MUITooltip
      PopperProps={{ ...PopperProps, sx: mergeSX(buildTooltipSX(), PopperProps.sx) }}
      {...restProps}
    >
      <Box
        ref={ref as Ref<HTMLDivElement>}
        sx={mergeSX(buildBoxSX({ cursorPointer }), boxSX)}
      >
        {children}
      </Box>
    </MUITooltip>
  );
});

export default Tooltip;
